// React and hooks
import React, { useState, useEffect } from 'react';

// Routing
import { NavLink } from 'react-router-dom';

// UI Components (from React Bootstrap)
import { Row, Col, Card, Modal, Button, Form, InputGroup } from 'react-bootstrap';

// Utils and error handlers
import moment from 'moment';
import { handlerErrors } from 'utils/handleErrors';

// UI Libraries
import { Application, FileSelector } from 'react-rainbow-components';
// Custom Components
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import ConnectionError from 'components/emptyStates/ConnectionError';
import ButtonRequest from '../../../components/buttons/ButtonRequest';

// components
import LoadingCar from '../../../components/loading/LoadingCar';
import EmptyPage from '../../../components/emptyStates/EmptyPage';
import { ToastErrorCath, ToastSuccess } from '../../../components/alerts/toast';
import ProvisionalUserAlert from '../../../components/alerts/UserAlert';

// API calls
import { getPluginShops, editPluginStore } from '../../../api/Api-user';

const Stores = () => {
  const title = 'Tiendas Integradas';
  const description = 'Integraciones Plataforma Autopaquete';
  // -Local States
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [storeList, setStoreList] = useState([]);
  const [emptyHistory, setEmptyHistory] = useState(null);
  const [hasConnectionIssue, setHasConnectionIssue] = useState(false);
  const [isModalActive, setIsModalActive] = useState(false);
  const [selectedStore, setSelectedStore] = useState({});
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [trigger, setTrigger] = useState(false);

  const [shopName, setShopName] = useState(''); // to edit
  const [file, setFile] = useState(null); // to edit

  const theme = {
    rainbow: {
      palette: {
        brand: '#850000',
      },
    },
  };
  const handleEditStore = async () => {
    setIsBtnLoading(true);
    const data = {
      name: shopName,
      id: selectedStore.store_ecommerce_id,
      ...(file && (file instanceof File || file[0]) && { img: file[0] || file }),
    };
    try {
      if (!shopName) {
        ToastErrorCath('Por favor ingresa un nombre de tienda antes de editar.');
        return; // Terminar la ejecución
      }
      const response = await editPluginStore(data);
      // console.log('Edit store response:', response);
      if (response.success) {
        setIsModalActive(false);
        ToastSuccess('✨ Actualización exitosa ');
        // REFRESH PAGE
        setTrigger(!trigger);
      }
    } catch (error) {
      handlerErrors(error);
    } finally {
      setIsBtnLoading(false);
    }
  };
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('localIntegrationsState'));
    if (storedData?.stores) {
      setStoreList(storedData.stores);
    }
    getPluginShops()
      .then((response) => {
        // console.log('res getPluginShops:', response.stores);
        if (response.stores !== undefined) {
          setStoreList(response.stores);
          if (response.stores.length === 0) {
            setEmptyHistory(storedData.stores || true); // para mostrar mensaje de "No tienes historial"
          }
          // Obtener lo que ya existe en localIntegrationsState
          const prev = JSON.parse(localStorage.getItem('localIntegrationsState')) || {};
          // Guardar la nueva data combinada
          const updated = {
            ...prev,
            stores: response.stores,
          };
          localStorage.setItem('localIntegrationsState', JSON.stringify(updated));
        }
      })
      .catch((error) => {
        setHasConnectionIssue(true); // only show component if this is true and history list is empty
        handlerErrors(error);
      })
      .finally(() => {
        setIsInitialLoading(false);
      });
  }, [trigger]);
  return (
    <>
      {isInitialLoading && <LoadingCar />}
      <Modal show={isModalActive} onHide={() => setIsModalActive(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">Editar</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-infow">
          <>
            <Form.Label>Nombre</Form.Label>
            <span className="text-primary ms-1">*</span>
            <InputGroup>
              <InputGroup.Text>
                <CsLineIcons icon="shop" size="16" className="text-alternate" />
              </InputGroup.Text>
              <Form.Control
                type="text"
                value={shopName}
                onChange={(e) => {
                  setShopName(e.target.value);
                }}
              />
            </InputGroup>
            {/* <span className="text-medium">{helpText}</span> */}
            <Application theme={theme}>
              <FileSelector
                className="rainbow-m-vertical_x-large  rainbow-m_auto"
                // style={containerStyles}
                // label="Subir archivo excel"
                placeholder="Sube una nueva imagen para tu tienda"
                bottomHelpText="Recuerda: solo puedes subir un archivo JPG, PNG o WEBP"
                onChange={setFile}
                borderRadius="semi-rounded"
              />
            </Application>
          </>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex flex-wrap justify-content-end bg-warningd">
            <Button variant="outline-primary" style={{ height: '36px' }} className="w-auto me-2 mb-2" onClick={() => setIsModalActive(false)}>
              Cancelar
            </Button>
            <ButtonRequest
              title="Editar"
              titleLoading="Editando"
              handlerFn={handleEditStore}
              isButtonDisabled={isBtnLoading} // si esta cargando el bt esta deshabilitado para evitar doble peticion
              isLoading={isBtnLoading}
            />
          </div>
        </Modal.Footer>
      </Modal>

      {/* pageContainer I use it to add opacity screen while loading data */}
      <div id="pageContainer">
        <HtmlHead title={title} description={description} />
        <div className="page-title-container">
          <Row className="g-0">
            {/* Title Start */}
            <Col className="col-auto mb-3 mb-sm-0 me-auto order-1">
              <NavLink className="muted-link pb-1 d-inline-block hidden breadcrumb-back" to="/">
                <CsLineIcons icon="chevron-left" size="13" />
                <span className="align-middle text-small ms-1">Inicio</span>
              </NavLink>
              <h1 className="mb-0 pb-0 display-4" id="title">
                {title}
              </h1>
            </Col>
            {/* Title End */}
          </Row>
        </div>
        <hr className="bg-muted mb-3 mt-5" />
        <ProvisionalUserAlert title="Tiendas e-commerce" />
        <div style={{ minHeight: '50vh' }} id="cardContainer">
          {storeList?.length === 0 && hasConnectionIssue && <ConnectionError refreshBtn />}
          {emptyHistory && (
            <EmptyPage
              text="Aún no has conectado ninguna tienda. Integra tu tienda con uno de nuestros plugins para comenzar a gestionar tus pedidos desde aquí."
              btnText="Conoce cómo integrar tu tienda"
              path="/integraciones/documentacion"
              isCallToAction
              showAnimation
            />
          )}
          {storeList?.length > 0 && (
            <>
              {/* List shipment Items Start */}
              <Row className="g-0">
                {storeList?.map((store, index) => (
                  <Col xs="12" md="12" xl="6" key={index} className="mb-2 pe-2">
                    <Card>
                      {/* sh-lg-9 */}
                      <Row className="g-0 h-100">
                        <Col
                          xs="auto"
                          className="position-relative rounded-top-start rounded-bottom-start overflow-hidden d-flex justify-content-center align-items-center"
                        >
                          {/* sw-sm-20 */}
                          <img src={store.store_pic} alt="servicio" className="d-sm-none card-img card-img-horizontal sw-11 h-100" />
                          <div className="d-none d-sm-flex h-100 sh-lg-9 justify-content-center align-items-center bg-infox" style={{ width: '200px' }}>
                            <img src={store.store_pic} alt="tienda" className="bg-successx w-100" />
                          </div>
                        </Col>
                        <Col className="py-4 ps-3 pe-4 h-100">
                          <Row className="g-0 h-100 align-content-center">
                            <Col xs="12" className="d-flex flex-column  mb-3 pe-3  justify-content-center">
                              <div className="text-muted text-small">Nombre</div>
                              <div className="text-primary text-truncate">{store.name}</div>
                            </Col>
                            <Col xs="10" sm="6" className="d-flex flex-column pe-1 mb-2  justify-content-center">
                              <div className="text-muted text-small">Fecha de instalación</div>
                              <div>{moment(store.created).format('DD/MM/YY')}</div>
                            </Col>
                            <Col xs="2" sm="6" className="d-flex flex-column pe-1 mb-2  justify-content-center align-items-end">
                              <div className="text-muted text-small">Activa</div>
                              <span>
                                <CsLineIcons icon="check" className="text-success" size="15" />
                              </span>
                            </Col>
                            <Col xs="12" sm="6" className="d-flex flex-column pe-1 mb-2  justify-content-center">
                              <div className="text-muted text-small">Integración eCommerce</div>
                              <div className="text-truncate">{store.ecommerce_platform}</div>
                            </Col>
                            <Col xs="12" sm="6" className="d-flex flex-column pe-1 mb-2 justify-content-center align-items-end">
                              <div className="text-muted text-small">Editar</div>
                              <span
                                onClick={() => {
                                  setSelectedStore(store);
                                  setIsModalActive(true);
                                  setShopName(store.name);
                                }}
                                className="btn-link cursor-pointer"
                              >
                                <CsLineIcons icon="edit" size="15" />
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                ))}
              </Row>
              {/* List shipment Items End */}
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default Stores;
